import {ActionWithPayload} from '../../../helpers/reduxHelpers';
import {ThunkAction} from '../../appThunk';

/*
 * Action types.
 */

export enum VacationResponderActionsEnum {
  VACATION_RESPONDER_DELETED = '@@data/vacation_responders/VACATION_RESPONDER_DELETED',
}

/*
 * Types.
 */

export interface VacationResponderDeletedAction extends ActionWithPayload<number> {
  type: VacationResponderActionsEnum.VACATION_RESPONDER_DELETED;
}

/*
 * Action creators.
 */

export function deleteVacationResponderAction(vacationResponderId: number): ThunkAction {
  return async (dispatch, getState) => {
    // If we don't have this vacation responder, nothing to do.
    const existingVacationResponder = getState().data.vacationResponders[vacationResponderId];
    if (!existingVacationResponder) {
      return null;
    }

    const action: VacationResponderDeletedAction = {
      type: VacationResponderActionsEnum.VACATION_RESPONDER_DELETED,
      payload: vacationResponderId,
    };
    return dispatch(action);
  };
}

/*
 * Union type.
 */

export type VacationRespondersAction = VacationResponderDeletedAction;
